import React, { useEffect, useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { Swiper, SwiperSlide, Autoplay, Pagination, TypeSwiper } from '../../services/ImportsSwiper';
import './BlockCarousel.scss';
import './BlockCarousel-media.scss';
import { Props } from './interfaces';
import { MediaContent } from '../../services/GlobalFunctions';

const BlockCarousel = ({ title, list, widthWindow, offsetContent }: Props) => {
  const [numActiveSlide, setNumActiveSlide] = useState(1);

  const Changed = (current: TypeSwiper) => setNumActiveSlide(current.realIndex + 1);

  const [slider, setSlider] = useState<TypeSwiper>();
  const settings = {
    onInit: (slider: TypeSwiper) => setSlider(slider),
    autoplay: false,
    speed: 500,
    loop: true,
    modules: [Autoplay, Pagination],
    onSlideChange: Changed,
    className: 'slider-carousel',
    spaceBetween: 20,
  };

  const settingsMain = {
    ...settings,
    slidesPerView: list.length <= 4 ? list.length : 4,
    centeredSlides: list.length > 4,
  };

  const settingsMob = { ...settings, slidesPerView: 1, centeredSlides: true, width: widthWindow - 80 };

  const prevSlide = () => {
    if (slider) {
      slider.slidePrev(500, false);
    }
  };
  const nextSlide = () => {
    if (slider) {
      slider.slideNext(500, false);
    }
  };

  const listLong = list.length >= 5 ? [...list, ...list] : list;

  const stylesBlock = { transform: `translateX(-${offsetContent}px)` };

  const content = (
    <>
      {listLong.map(({ image, title, text }, i) => (
        <SwiperSlide key={i}>
          <div
            className={`block-carousel__slide ${
              i + 1 === numActiveSlide && list.length > 4
                ? 'block-carousel__slide_active'
                : 'block-carousel__slide_not-active'
            }`}
            style={image ? { backgroundImage: `url(${image})` } : {}}
          >
            <h4 className="block-carousel__slide-title">{title}</h4>
            <p className="body2">{text}</p>
          </div>
        </SwiperSlide>
      ))}
    </>
  );

  return list.length ? (
    <div className="block-carousel" style={widthWindow > 720 && widthWindow < 1440 ? stylesBlock : {}}>
      <h2 className="block-carousel__title">{title}</h2>

      {MediaContent(
        <Swiper {...settingsMain}>
          {content}
          <div className="block-carousel__gradient block-carousel__gradient_left" />
          <div className="block-carousel__gradient block-carousel__gradient_right" />

          <div
            className="block-carousel__arrow block-carousel__arrow_prev"
            onClick={prevSlide}
            style={{ left: '20px' }}
          />
          <div
            className="block-carousel__arrow block-carousel__arrow_next"
            onClick={nextSlide}
            style={{ right: '20px' }}
          />
        </Swiper>,
        <Swiper {...settingsMob}>{content}</Swiper>
      )}
    </div>
  ) : null;
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(BlockCarousel));

const getPosArrow = (offsetContent: number) => {
  const slider = document.querySelector('.slider-carousel');
  if (slider) {
    const offsetBlock = slider.getBoundingClientRect().x;

    return offsetContent - offsetBlock;
  }

  return 0;
};
